// export { default } from './Layout'

import React, { useState, useCallback } from "react"

let Layout = () => <div>Loading...</div>
let loaded = false

const PreLayout = props => {
	const [, setState] = useState()

	const loadLayout = useCallback(() => {
		import(/* webpackChunkName: "chunks/public/Layout" */ './Layout')
			.then(m => (Layout = m.default, loaded = true, setState({})))
	}, [])

	!loaded && loadLayout()
	return <Layout {...props} />
}

export default PreLayout